var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"tab-element",class:[{ tiny: _vm.tiny, big: _vm.big }, _vm.bgColor]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }